import { css } from 'styled-components';
import { FormComponentProps } from '../../components/types';
import { theme } from '../../theme';

const { colors, sizes } = theme;

/**
 *
 * @deprecated
 * use css modules instead from src/utils/forms/form.module.scss
 *
 */
export const inputVariableStyles = ({ hasError, compact }: FormComponentProps) => css`
  --padding: ${sizes[3]};
  --padding-right: var(--padding);
  --outline-size: ${compact ? '2px' : sizes.xs};
  --border-color: ${hasError ? colors.secondary.red.base : colors.neutral.ink.lightest};
  --shadow-color: ${hasError ? colors.secondary.red.light : colors.secondary.blue.light};
`;
